import axiosLogin from "global/helpers/axiosLogin";
import axiosInstance from "../../../helpers/axiosInstance";
import {
  LOGIN_ERROR,
  LOGIN_LOADING,
  LOGIN_SETUSUARIO,
  LOGIN_SUCCESS,
  LOGOUT_USER,
} from "../../ActionTypes";

export const setUsuarioAuth = (usuario, nextStep) => (dispatch) => {
  if (usuario !== null) {
    sessionStorage.token = usuario.token;
  }
  dispatch({
    type: LOGIN_SETUSUARIO,
    payload: usuario,
  });
  if (nextStep) nextStep();
};

export const login =
  ({ txtDni, txtPassword }, sectorTurno, nextStep) =>
  (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .post("/shared/Auth/legacy-login", {
          password: txtPassword,
          nro_documento: txtDni,
          sectorTurno,
        })
        .then((res) => {
          sessionStorage.token = res.data.token;
          sessionStorage.refreshToken = res.data.refreshToken;

          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          });
          if (nextStep) {
            nextStep(res.data.token, res.data);
          }
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data.detail
              : "Error al contactar el server.",
            origen: "portal",
            status: err.response.status,
          };

          dispatch({
            type: LOGIN_ERROR,
            payload: error,
          });
        });
    });
  };

export const logoutAuth = () => (dispatch) => {
  dispatch({ type: LOGOUT_USER });
};

export const wsGetAuthToken = (token, nexStep) => (dispatch) => {
  dispatch({
    type: LOGIN_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`shared/Auth/legacy/authtoken/${token}`)
      .then((res) => {
        sessionStorage.token = res.data.token;
        dispatch({
          type: LOGIN_SUCCESS,
          payload: res.data,
        });
        if (nexStep) {
          nexStep(true, res.data);
        }
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: LOGIN_ERROR,
          payload: error,
        });
        if (nexStep) {
          nexStep(false, err);
        }
      });
  });
};

export const wsPostTokenValidation =
  (idApp, history, set, idPaciente, to, sectorTurno) => (dispatch) => {
    set(true);
    sessionStorage.setItem("idApp", idApp);

    axiosInstance().then((respuesta) => {
      respuesta
        .post(`/authAuto`, {
          id: Number(idPaciente),
          descripcion: idApp,
          sectorTurno: sectorTurno,
        })
        .then((resp) => {
          dispatch({ type: LOGIN_SUCCESS, payload: resp.data });
          if (resp.data.token) {
            sessionStorage.setItem("token", resp.data.token);
            sessionStorage.setItem("auth", JSON.stringify(resp.data));
            set(false);
            history.push(to);
          } else {
            set(false);
          }
        })
        .catch((err) => {
          set(false);
        });
    });
  };

export const wsPostLoginSegundoFactor =
  ({ txtUsuario, txtPassword }) =>
  (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .post("shared/AuthUsuario/login", {
          usuario: txtUsuario,
          password: txtPassword,
        })
        .then((res) => {
          sessionStorage.token = res.data.token;
          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: LOGIN_ERROR,

            payload: error,
          });
        });
    });
  };
